import React, { useEffect, useState } from 'react'
import PostSingle from './PostSingle'
import ReadMore from './ReadMore'
import { Advertisement } from '../advertisement/Advertisement'
import NextPosts from './NextPosts'

export const PostTemplate = ({ post, readmorePosts }) => {
  const [isPreview, setIsPreview] = useState(false)
  const categoryId = post?.categories?.cats?.[0]?.id;

  const adplacement =
    categoryId === 'dGVybToxMjk4NQ=='
      ? 'betong'
      : categoryId === 'dGVybToy' 
      ? 'arkitekt'
      : null; 

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsPreview(window.location.search.includes('preview_id'))
    }
  }, [])

  return (
    <div className="innerContainer">
      <PostSingle post={post} />
      <ReadMore posts={readmorePosts} />
      <div
        style={{
          height: '126px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          margin: '8rem 0 8rem calc((-100vw + 100%) / 2)',
          width: '100vw',
        }}
      >
        {!isPreview && <Advertisement size="large" borderRadius="0" adplacement={adplacement}/>}
      </div>
      {!isPreview && <NextPosts post={post} />}
    </div>
  )
}
